import React from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './pages'
import './i18n'

const container = document.getElementById('root')

if (!container) throw new Error('Root container is missing in index.html')

createRoot(container).render(<App />)
